import {Logger} from '../utils/Logger';
import { MatDialog } from '@angular/material/dialog';
import {Validator} from '../utils/Validator';
import {Scheduler} from '../utils/Scheduler';
import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Toaster, Type} from '../toaster/Toaster';
import {Type as Constructor} from '@angular/core';
import {UserService} from '../service/user.service';
import {Step} from '../application-flow/steps/step';
import {UserNavigator} from '../utils/UserNavigator';
import {ActivatedRoute, Router} from '@angular/router';
import {TermsComponent} from '../terms/terms.component';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {ReferralService} from '../service/referral.service';
import {Keys, StorageService} from '../service/storage.service';
import {EntityConflictError} from '../errors/EntityConflictError';
import {LenderDetailsService} from '../service/lender-details.service';
import {UnprocessableEntityError} from '../errors/UnprocessableEntityError';
import {BasePhoneVerificationComponent} from '../phoneverification/base-phone-verification.component';

@Component({
    selector: 'app-lenderphoneverification',
    templateUrl: './lenderphoneverification.component.html',
    styleUrls: ['./lenderphoneverification.component.css'],
    providers: [ApiServiceService, ReferralService, LenderDetailsService]
})
export class LenderPhoneVerificationComponent extends BasePhoneVerificationComponent implements OnInit {
    otp: string;
    loader = false;
    disableBtn = true;
    otpDisabled = false;
    termsChecked = false;
    mobileOtpError = false;
    checkboxDisabled = false;
    sendOtpButtonEvent = false;
    phoneNumberDisabled = false;
    private dialog: MatDialog;
    private userNavigator: UserNavigator;
    private lenderDetailsService: LenderDetailsService;
    public readonly analyticsTracker: AnalyticsTracker;

    constructor(dialog: MatDialog, http: HttpClient, ref: ApiServiceService, lenderDetailsService: LenderDetailsService, router: Router,
                validator: Validator, storageService: StorageService, scheduler: Scheduler,
                userNavigator: UserNavigator, userService: UserService, activatedRoute: ActivatedRoute,
                analyticsTracker: AnalyticsTracker) {
        super(http, validator, ref, storageService, scheduler, userService, router, activatedRoute, analyticsTracker, null);
        this.analyticsTracker = analyticsTracker;
        this.dialog = dialog;
        this.userNavigator = userNavigator;
        this.lenderDetailsService = lenderDetailsService;
    }

    openDialog() {
        this.dialog.open(TermsComponent, {height: '500px', width: '600px'});
    }

    onPhoneInput(event) {
        this.mobileError = false;
        console.log(event.target.value);
        this.phoneNumber = event.target.value.replace(/[^0-9]+/, '');
        if (event.target.value.length == 10) {
            if (event.target.value.match(/[6789][0-9]{9}/)) {

            } else {
                this.mobileError = true;
                this.mobileErrorMsg = 'Please provide a valid mobile number';
                return false;
            }
        }
    }

    async submitOtpVerification(formData) {
        this.disableBtn = false;
        this.loader = true;

        if (this.isLenderProfileAssociated()) {
            formData.check1 = true;
            formData.check2 = true;
        }

        this.clearValidationErrors();

        if (this.validateForm(formData)) {
            if ((this.storageService.getItem(Keys.IS_OTP_VERIFIED) === 'true')) {
                this.loader = true;
                this.disableBtn = false;

                const profileId = this.storageService.getItem(Keys.PROFILE_ID);

                try {
                    if (!this.isLenderProfileAssociated()) {
                        await this.createLender(profileId);
                    }
                } catch (error) {
                    Logger.log(`Couldn't create lender details for user`);
                    if (error instanceof EntityConflictError) {
                        Logger.log(`User is already a lender!`);
                        this.router.navigate(['/invest/email-verification']);
                    }
                }
                this.router.navigate(['/invest/email-verification']);
            } else {
                await this.verifyOtp(formData);
            }
        }
    }

    ngOnInit() {
        if (this.isLenderProfileAssociated()) {
            this.termsChecked = true;
        }

        if (this.storageService.getItem(Keys.IS_OTP_VERIFIED) == 'true' && this.storageService.getItem(Keys.PAN_VERIFIED) == 'true') {
            this.http.post(this.ref.baseURL() + 'getProfileDetails', {
                    profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                    token: this.storageService.getItem(Keys.TOKEN)
                })
                .subscribe((result2: any) => {
                    if (result2.status === 'Success') {
                        this.phoneNumber = result2.mobile_no;
                        this.fieldDisabledTag = true;
                        this.phoneNumberDisabled = true;
                        this.otpDisabled = true;
                        this.checkboxDisabled = true;
                    } else {
                    }

                });
        } else if (this.storageService.getItem(Keys.PAN_VERIFIED) == 'true') {
            this.fieldDisabledTag = false;
            this.phoneNumberDisabled = false;
            this.otpDisabled = false;
            return false;
        } else {

        }
    }

    shouldShowConsentCheckboxes(): boolean {
        return (!this.isLenderProfileAssociated() && this.userNavigator.isUserLoggedIn()) || this.showOtp;
    }

    async onUserCreatedSuccessfully(): Promise<void> {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        await this.createLender(profileId);
        await this.navigateToNextStep();
    }

    async onPhoneVerificationFailed(error: any): Promise<void> {
        this.loader = false;
        this.disableBtn = true;
        if (error instanceof UnprocessableEntityError) {
            this.mobileOtpError = true;
        } else {
            Toaster.toast(`Something went wrong. Please try again later.`, Type.Error);
        }
    }

    async onUserCreationFailed(): Promise<void> {
        this.loader = false;
        this.disableBtn = true;
        this.mobileOtpError = false;
    }

    private async createLender(profileId) {
        const lenderDetails = await this.lenderDetailsService.createLenderDetails(profileId);
        this.storageService.saveItem(Keys.LENDER, 'true');
        this.storageService.saveItem(Keys.LENDER_ID, lenderDetails._id);
    }

    private validateForm(formData: any) {
        if ((!!formData.check1 !== true || !!formData.check2 !== true) && this.shouldShowConsentCheckboxes()) {
            this.loader = false;
            this.disableBtn = true;
            this.checkError = true;
            return false;
        } else if ((!this.phoneNumber) || this.phoneNumber.length !== 10) {
            this.loader = false;
            this.disableBtn = true;
            this.mobileError = true;
            this.mobileErrorMsg = 'Please provide a valid mobile number';
            return false;
        } else if ((!((this.sendOtpButtonEvent === true) && (!!formData.otp))) && (!!(this.storageService.getItem(Keys.IS_OTP_VERIFIED) !== 'true'))) {
            this.loader = false;
            this.disableBtn = true;
            this.mobileError = true;
            this.mobileErrorMsg = 'Click on SEND OTP to continue';
            return false;
        }
        return true;
    }

    private isLenderProfileAssociated(): boolean {
        return !!this.storageService.getItem(Keys.LENDER_ID);
    }

    private clearValidationErrors() {
        this.checkError = false;
        this.mobileOtpError = false;
        this.mobileError = false;
        this.loader = false;
        this.disableBtn = true;
    }

    private async verifyOtp(formData: any) {
        if ((this.sendOtpButtonEvent === true) && (formData.otp)) {
            this.loader = true;
            this.disableBtn = false;
            await this.verifyOtpAndCreateUser(formData.otp);
        }
    }

    protected errorMessages(): object {
        return {};
    }

    step(): Constructor<Step> {
        return undefined;
    }
}
